import { LogLevel } from '@azure/msal-browser';

export const msalConfig = {
    auth: {
        clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
        authority: process.env.REACT_APP_AZURE_AD_AUTHORITY,
        redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI || window.location.origin,
        postLogoutRedirectUri: process.env.REACT_APP_AZURE_AD_POST_LOGOUT_REDIRECT_URI || window.location.origin,
        navigateToLoginRequestUrl: false,
    },
    cache: {
        cacheLocation: 'sessionStorage',
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) return;

                if (process.env.NODE_ENV === 'production') {
                    if (level === LogLevel.Error) console.error(message);
                    if (level === LogLevel.Warning) console.warn(message);
                } else {
                    if (level === LogLevel.Error) console.error(message);
                    if (level === LogLevel.Warning) console.warn(message);
                    if (level === LogLevel.Verbose) console.debug(message);
                }
            },
        },
    },
};

export const loginRequest = {
    scopes: ['User.Read']
};